export default __webpack_public_path__ + "img/instra2.794f056d.jpg";